import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Lock, ArrowLeft, BadgeCheck } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { MODULE_LABELS } from "../lib/modules";

// Pantalla para un módulo que el plan contratado no incluye.
export const LockedModule = ({ moduleKey, inline = false }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [plans, setPlans] = useState(null);
  useEffect(() => {
    api.get("/plans/for-module", { params: { module: moduleKey } }).then((r) => setPlans(r.data)).catch(() => setPlans([]));
  }, [moduleKey]);
  const names = (plans || []).map((p) => p.name).join(" o ");
  return (
    <div className={`${inline ? "" : "min-h-screen"} flex items-center justify-center p-6 bg-[#F8FAFC]`} data-testid="locked-module">
      <div className="max-w-md w-full bg-white rounded-3xl border border-[#111827]/10 p-8 text-center shadow-sm">
        <span className="mx-auto w-16 h-16 rounded-2xl bg-[#E85D04]/10 text-[#E85D04] flex items-center justify-center"><Lock size={30} /></span>
        <h1 className="font-heading text-2xl font-extrabold text-[#111827] mt-4">{MODULE_LABELS[moduleKey] || "Módulo"}</h1>
        <p className="text-[#111827]/60 mt-2" data-testid="locked-module-text">
          Este módulo no está incluido en tu plan actual.{plans === null ? "" : names ? <> Estará disponible en el plan <b>{names}</b>.</> : " Estará disponible en otro plan."}
        </p>
        <div className="flex flex-col gap-2 mt-6">
          {user?.role === "admin" && (
            <Link to="/app/suscripcion" data-testid="locked-upgrade-btn" className="h-12 rounded-xl bg-[#E85D04] text-white font-semibold flex items-center justify-center gap-2 hover:bg-[#C2410C]">
              <BadgeCheck size={18} /> Mejorar mi plan
            </Link>
          )}
          {user?.role !== "admin" && <p className="text-xs text-[#111827]/50">Pide al administrador que mejore el plan.</p>}
          <button data-testid="locked-back-btn" onClick={() => navigate("/app")} className="h-11 rounded-xl border border-[#111827]/15 font-semibold flex items-center justify-center gap-2 hover:bg-[#111827]/5">
            <ArrowLeft size={16} /> Volver al inicio
          </button>
        </div>
      </div>
    </div>
  );
};
